import { render, staticRenderFns } from "./StepForm.vue?vue&type=template&id=a879d9f8&scoped=true&"
import script from "./StepForm.vue?vue&type=script&lang=js&"
export * from "./StepForm.vue?vue&type=script&lang=js&"
import style0 from "./StepForm.vue?vue&type=style&index=0&id=a879d9f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a879d9f8",
  null
  
)

export default component.exports